import React, { useEffect } from "react";
import moment from "moment";
import {
  useForm,
  FormProvider,
  useFormContext,
  useWatch,
} from "react-hook-form";
//Component
import { MaterialUIDatePickers } from "./../../stories/hook-controls/datepicker/datepicker";
import { MaterialUIMonthPickers } from "./../../stories/hook-controls/datepicker/monthpicker";
//Material
import Box from "@material-ui/core/Box";
import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";
//function
import { MuiDateTimeToApi, ApiDateTimeFormat } from "../../utils/date";
function Criteria(props) {
  const { query, month = false } = props;
  const { setValue, getValues } = useFormContext();
  useEffect(() => {
    let date = ( month ? moment() : moment().subtract(1, "days")).format(ApiDateTimeFormat)
    setValue("date", date);
  }, [setValue,month]);
  function adjdate(val) {
    let txt = month ? "month" : "days";
    let newdate = moment(getValues().date).add(txt, val);
    setValue("date", MuiDateTimeToApi(newdate));
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      m={3}
      flexDirection="column"
      alignItems="center"
    >
      <Box
        display="flex"
        alignItems="center"
        width="100%"
        justifyContent="center"
      >
        <Box>SelectedDate :</Box>
        <Box ml={1}>
          {month ? (
            <MaterialUIMonthPickers name="date" />
          ) : (
            <MaterialUIDatePickers name="date" />
          )}
        </Box>
        <Box ml={1} className="btnstyle">
          <Button variant="contained" onClick={query}>
            {" "}
            Query{" "}
          </Button>
        </Box>
      </Box>
      <Box display="flex" alignItems="center">
        <Link href="#" onClick={() => adjdate(-1)}>
          {"< Previous "}
        </Link>
        &nbsp;<Link>{"|"}&nbsp;</Link>
        <Link href="#" onClick={() => adjdate(1)}>
          {"Next >"}
        </Link>
      </Box>
    </Box>
  );
}

export default Criteria;
